import React from 'react';
import Box from '@mui/material/Box';
import { useLocation } from 'react-router-dom';

import AppAppBar from './components/AppAppBar';
import Hero from './components/Hero';
import NizroTeaser from './components/NizroTeaser';
import Services from './components/Services';
import OurClients from './components/OurClients';
import AboutUs from './components/AboutUs';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { Seo } from './components/Seo';

export default function LandingPage() {
  const location = useLocation();

  // Cross-page anchor nav lands here as `/#section` (e.g. from AppAppBar or
  // Footer while the visitor is on /nizro). Scroll to it once the section
  // exists in the DOM; a short delay covers the case where we just navigated
  // in from another route and layout hasn't settled yet.
  React.useEffect(() => {
    if (!location.hash) return undefined;
    const id = location.hash.slice(1);
    const timer = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 60);
    return () => clearTimeout(timer);
  }, [location.hash, location.key]);

  return (
    <Box sx={{ bgcolor: 'background.default', color: 'text.primary' }}>
      <Seo page="home" path="" />
      <AppAppBar />
      <Box component="main">
        <Hero />
        {/* Nizro sits directly under the hero: it is the only thing on this
            site a visitor can buy today, and the one with a dated reason to
            act (the Fawtara rollout). Full pitch, trade picker and deep dive
            now live at /nizro — this is just the pointer. Services follow. */}
        <NizroTeaser />
        <Services />
        <OurClients />
        <AboutUs />
        <Contact />
      </Box>
      <Footer />
    </Box>
  );
}
